import { Component , OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../_services/index';
import { FormBuilder, FormGroup } from '@angular/forms';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import { environment } from 'environments/environment';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import {GridDataResult,DataStateChangeEvent} from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs/Observable'; 
import { ExcelExportData } from '@progress/kendo-angular-excel-export';

declare var $: any;

import { UccUsersService } from '../../reports/uccReport/uccUsers.service';
import { UccPermsService } from './UccPerms.service';
import { uccUsers } from '../../reports/uccReport/uccUsers.model';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { getDatabase, ref, onValue} from "firebase/database";
import { utils, write, WorkBook } from 'xlsx';


import * as XLSX from 'xlsx';

import { saveAs } from 'file-saver';
import { forEach } from 'lodash';


declare var firebase: any;

@Component({
    selector: 'vts-status',
    templateUrl: './vtsStatus.component.html',
})

export class VtsStatusComponent {

    firebase:any;
    
     public LucknowProject:any;
     public GurugramProject:any;
     public FaridabadProject:any;  
     public GwaliorProject:any;
      
     file = false ;
   
     data: any;

     public prjId:any;
     public id: string;


  

    constructor(private fb: FormBuilder,private http: HttpClient, private auth: AuthService, public afs: AngularFirestore){
      
     
    

    }

    ngOnInit() {

    this.prjId = this.auth.getAuthentication().projectId
    this.id = this.auth.getAuthentication().id;

  
    
    
    var config = {
        authDomain: 'ecogreen-citizen-app.firebaseapp.com',
        apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
        databaseURL: 'HttpClient s://ecogreen-citizen-app-2ad05.firebaseio.com/',
        storageBucket: 'ecogreen-citizen-app.appspot.com',
        projectId: 'ecogreen-citizen-app'
    };
     
    firebase.initializeApp(config);

    this.get_Data();


    
 

    }


    get_Data() {
           
        var LUCKNOW = [] ;

        var GURUGRAM = [] ;

        var FARIDABAD = [] ;

        var GWALIOR = [] ;

        var ggn = 0 ;

       

        firebase.database().ref('/').once('value', async (snapshot) => {
            snapshot.forEach(function(childSnapshot) {
                // key will be "ada" the first time and "alan" the second time
                var key = childSnapshot.key;
                // childData will be the actual contents of the child
                var childData = childSnapshot.val();

                if (childData.prjID == 1) {
                    // LUCKNOW 1
                    LUCKNOW.push(childData);

                  } else if (childData.prjID == 2) {
                    // GURUGRAM 2
                    GURUGRAM.push(childData);
                    ggn++

                  } else if (childData.prjID == 3){
                    // FARIDABAD 3
                    FARIDABAD.push(childData);


                  }else {
                      // GWALIOR
                      GWALIOR.push(childData);

                  }
               
             });

          });

          
         this.FaridabadProject =  FARIDABAD ;
         this.GurugramProject  =  GURUGRAM ; 
         this.GwaliorProject   =  GWALIOR ;
         this.LucknowProject   =  LUCKNOW 

    }




    //  


///// excel testing atul 

     



// excell testing 

 
  //  onFileChange(evt:any) {
  //    const target : DataTransfer =  <DataTransfer>(evt.target);
  //    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

  //    const reader: FileReader = new FileReader();
  //    reader.onload = (e: any) => {
  //    const bstr: string = e.target.result;
  //    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
  //    const wsname : string = wb.SheetNames[0];
  //    const ws: XLSX.WorkSheet = wb.Sheets[wsname];
  //    this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
  //    let x = this.data.slice(1);
    

  //    //console.log(jasondata);

  //  };

  //   reader.readAsBinaryString(target.files[0]);





  // }


    



  // saveExcellData(){
      
       
  //     let text = "are you sure to upload right file to save data ";
  //     if (confirm(text) == true) {
  //       text = "You pressed OK!";
  //       var jasondata = this.data  
  //       var finaljasondata =[]
  //       var len = jasondata.length
    
  //       for(var i = 2; i <len; i++) {
            
  //         finaljasondata.push({
  //          ZoneNumber:jasondata[i][1],
  //          WardNumber:jasondata[i][2],
  //          VehicleNumber:jasondata[i][3],
  //          RouteNumber:jasondata[i][4],
  //          NameOfArea:jasondata[i][5],
  //          MixedWate:jasondata[i][6],
  //          })
  //       } 
    
    
  //       console.log(finaljasondata);
        
  //       var apidata = {
  //         'data':finaljasondata,
  //         'projId':this.prjId,
  //         'userId':this.id
  //       };
          
  //       console.log(text);
  //       $("#fileInput").val("");
        
            
  //      this.http.post(environment.apiUrl + 'reports/SaveDoorToDoorMixedWastData', apidata).subscribe()
       
  //      this.file=true;
    
     


  //     } else {
  //       text = "You canceled!";

  //       console.log(text);
        
  //     }
      
    

    
    
    
    
   
    
  // }
 


    

 

    


}






// WEBPACK FOOTER //
// ./src/app/superAdmin/users/vtsStatus.component.ts